var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useEffect } from 'react';
import styled from 'styled-components';
import { AdornmentButton } from './AdornmentButton';
import { AdornmentStatic } from './AdornmentStatic';
import { AdornmentIcon } from './AdornmentIcon';
import { AdornmentDejarg } from './AdornmentDejarg';
import { TextBody } from '../../../../Typography/Text';
import { useFormTextContext } from '../../../context';
var StyledTextBody = styled(TextBody)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var colors = _a.theme.colors;
    return "\n    color: ".concat(colors['slate-4'], ";\n  ");
});
var CustomAdornment = React.forwardRef(function (_a, ref) {
    var variant = _a.variant, text = _a.text, icon = _a.icon, dejarg = _a.dejarg, onFormTextStateChange = _a.onFormTextStateChange, others = __rest(_a, ["variant", "text", "icon", "dejarg", "onFormTextStateChange"]);
    var _b = useFormTextContext({
        customError: 'CustomAdornment must be consumed inside of a FormText component',
    }), isFocused = _b.isFocused, isHovered = _b.isHovered, hasError = _b.hasError, isDisabled = _b.isDisabled;
    useEffect(function () {
        onFormTextStateChange === null || onFormTextStateChange === void 0 ? void 0 : onFormTextStateChange({ isFocused: isFocused, isHovered: isHovered, hasError: hasError, isDisabled: isDisabled });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFocused, isHovered, hasError, isDisabled]);
    var adornmentContent = useMemo(function () {
        return (React.createElement(React.Fragment, null,
            !!text && (React.createElement(StyledTextBody, { size: "md", tag: "span" }, text)),
            !!icon && React.createElement(AdornmentIcon, __assign({}, icon)),
            !!dejarg && React.createElement(AdornmentDejarg, __assign({}, dejarg))));
    }, [text, icon, dejarg]);
    return variant === 'interactive' ? (React.createElement(AdornmentButton, __assign({}, others, { ref: ref }), adornmentContent)) : (React.createElement(AdornmentStatic, __assign({}, others), adornmentContent));
});
export { CustomAdornment };
var templateObject_1;
//# sourceMappingURL=CustomAdornment.js.map